import { render, staticRenderFns } from "./modal-preview-file.vue?vue&type=template&id=071dade0"
import script from "./modal-preview-file.vue?vue&type=script&lang=js"
export * from "./modal-preview-file.vue?vue&type=script&lang=js"
import style0 from "./modal-preview-file.vue?vue&type=style&index=0&id=071dade0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports